import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
/**
 * Decorator component that automatically adjusts the width and height of a single child
 */

var AutoResizer = function AutoResizer(_ref) {
  var className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    children = _ref.children,
    onResize = _ref.onResize;
  var disableWidth = typeof width === 'number';
  var disableHeight = typeof height === 'number';
  if (disableWidth && disableHeight) {
    return React.createElement("div", {
      className: className,
      style: {
        width: width,
        height: height,
        position: 'relative'
      }
    }, children({
      width: width,
      height: height
    }));
  }
  return React.createElement(AutoSizer, {
    className: className,
    disableWidth: disableWidth,
    disableHeight: disableHeight,
    onResize: onResize
  }, function (size) {
    return children({
      width: disableWidth ? width : size.width,
      height: disableHeight ? height : size.height
    });
  });
};
export default AutoResizer;